// extracted by mini-css-extract-plugin
export var addViewLink = "_8-1";
export var availabilityIcon = "_8-16";
export var availabilitySelectionIcon = "_8-15";
export var backButton = "_8-2";
export var backIcon = "_8-z";
export var conversationCount = "_8-3";
export var dragHandle = "_8-5";
export var dropdown = "_8-e";
export var dropdownIcon = "_8-7";
export var dropdownOption = "_8-6";
export var dropdownTriangle = "_8-d";
export var expand = "_8-f";
export var folder = "_8-i";
export var folderItem = "_8-c";
export var icon = "_8-8";
export var iconRow = "_8-9";
export var image = "_8-a";
export var logo = "_8-b";
export var navContainer = "_8-h";
export var navigationFooter = "_8-g";
export var pageShell = "_8-0";
export var placeholderAvailable = "_8-11";
export var placeholderBox = "_8-14";
export var placeholderBusy = "_8-13";
export var placeholderUnavailable = "_8-12";
export var profile = "_8-k";
export var profileContainer = "_8-m";
export var profileDropdown = "_8-n";
export var profileImage = "_8-l";
export var profileMain = "_8-o";
export var profileSubtitle = "_8-q";
export var profileTitle = "_8-p";
export var reorderIcon = "_8-r";
export var sentLine = "_8-u";
export var settingsHeader = "_8-s";
export var sidenavTextColor = "_8-y";
export var spamLine = "_8-t";
export var subitemWithTag = "_8-4";
export var supportItems = "_8-j";
export var teamText = "_8-10";
export var viewLine = "_8-x";
export var viewLineButton = "_8-w";
export var viewLineButtons = "_8-v";